import React from "react";

import "./TimePicker.scss";

const TimePicker = ({ slot, setSlot, slots }) => {
  const scrollUp = () => {
    document.getElementById("list_wrapper").scrollBy({
      top: -50, // could be negative value
      left: 0,
      behavior: "smooth",
    });
  };

  const scrollDown = () => {
    document.getElementById("list_wrapper").scrollBy({
      top: 50, // could be negative value
      left: 0,
      behavior: "smooth",
    });
  };

  const onClickSlot = (e) => {
    setSlot(e.target.getAttribute("data-value"));

    // if (window.innerWidth < 769) {
    //   const element = document.getElementById("bookingCard");
    //   const headerOffset = 90;
    //   const elementPosition = element.getBoundingClientRect().top;
    //   const offsetPosition =
    //     elementPosition + window.pageYOffset - headerOffset;

    //   window.scrollTo({
    //     top: offsetPosition,
    //     behavior: "smooth",
    //   });
    // }
  };

  return (
    <div className="tp__wrapper" id="slotPicker">
      <div className="tp--divider">
        <h3>Pick a Slot</h3>
      </div>
      <div className="tp__container">
        <button className="btn__down" onClick={scrollUp}>
          &#8593;
        </button>
        <ul className="slot__list invisible-scrollbar" id="list_wrapper">
          {slots?.map((el, index) => (
            <li
              data-value={el?.slot}
              onClick={onClickSlot}
              key={index}
              className={`${
                el.isAvailable ? "slot__item" : "slot__unavailable"
              } ${el?.slot === slot ? "slot__selected" : ""}`}
            >
              {el?.slot}
            </li>
          ))}
        </ul>
        <button className="btn__up" onClick={scrollDown}>
          &#8595;
        </button>
      </div>
    </div>
  );
};

export default TimePicker;
